import { stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addTermSchema = object().shape({
    title: stringRequiredSchema,
    status: stringRequiredSchema
});

export default addTermSchema;